export default __webpack_public_path__ + "static/media/Letter T.848ffa51.mov";